<template>
	<div class="header-bar__container" :class="[invertClass, fixTopClass]">
		<div class="header-bar__navbar" :class="invertClass">
			<button class="header-bar__title button--link" :class="invertClass" @click="pushRoute(`home`)">
				<svg class="header-bar__logo" :class="invertClass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 837.36 119.19"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M59.47,96.12H41.93L16.88,28V96.12H0V4.88H27.29L51.42,72.25,75.55,4.88h26.64V96.12H84.52V28Z"/><path d="M124.86,119.19l9.49-25.84-26.9-67.77H127l16.48,43.77,16-43.77H177.6L142,119.19Z"/><path d="M175.75,4.88h20.57l24.13,68.17L244.71,4.88h19.52L229.81,96.12H210Z"/><path d="M290.33,24.39c22.28,0,36.92,15.56,36.92,36.39s-15.17,36.53-36.92,36.53c-22,0-36.79-15.43-36.79-36.26S269.1,24.39,290.33,24.39Zm.13,57c11.6,0,19.12-8.7,19.12-20.43s-7.91-20.57-19.25-20.57c-11.6,0-19.12,8.7-19.12,20.57S279.12,81.35,290.46,81.35Z"/><path d="M353.22,25.58H364v14.9H353.22V73.31c0,5.27,1.71,7.51,6.72,7.51H364v15a46.92,46.92,0,0,1-9.63.92c-13.31,0-18.85-6.73-18.85-18.46V40.48H329V25.58h6.59V14.5h17.67Z"/><path d="M385.39,66.59c.92,9.36,7.51,15,17.53,15,9,0,14.11-4.75,17.8-10.55L433.78,79c-4.22,8.83-13.72,18.33-30.86,18.33-21.36,0-36.12-13.85-36.12-36.26,0-21.1,14.24-36.66,34.67-36.66C422.7,24.39,436,38.24,436,59.33c0,1.72,0,4.22-.27,7.26Zm.39-13.32h31.91c-.79-7.91-6.72-14-16.35-14C392.38,39.29,386.71,45.22,385.78,53.27Z"/><path d="M492.31,57.88h-10V96.12H464.1V4.88h28.21c18.2,0,28,9.36,28,26.24C520.27,47.6,509.19,57.88,492.31,57.88Zm-10-37.18V42.06h8.57c6.73,0,10.42-4.35,10.42-10.81S497.59,20.7,490.86,20.7Z"/><path d="M556.92,43.77h-4.48c-6.86,0-9.23,3.3-9.23,9.37v43H525.54V25.58h17.67v5.67c2.5-3.56,6.46-5.93,13.71-5.93Z"/><path d="M595.42,24.39c22.28,0,36.92,15.56,36.92,36.39s-15.16,36.53-36.92,36.53c-22,0-36.79-15.43-36.79-36.26S574.19,24.39,595.42,24.39Zm.13,57c11.6,0,19.12-8.7,19.12-20.43s-7.91-20.57-19.25-20.57c-11.6,0-19.12,8.7-19.12,20.57S584.21,81.35,595.55,81.35Z"/><path d="M657,96.12c0,13.71-5.54,23.07-22.55,23.07H629.3V103.9h3.17c6.06,0,6.85-3.82,6.85-8V25.58H657ZM637.61,10.68a10.55,10.55,0,1,1,21.09,0,10.55,10.55,0,0,1-21.09,0Z"/><path d="M681.78,66.59c.92,9.36,7.51,15,17.53,15,9,0,14.11-4.75,17.8-10.55L730.17,79c-4.22,8.83-13.72,18.33-30.86,18.33-21.36,0-36.12-13.85-36.12-36.26,0-21.1,14.23-36.66,34.67-36.66,21.23,0,34.55,13.85,34.55,34.94,0,1.72,0,4.22-.27,7.26Zm.39-13.32h31.91c-.79-7.91-6.72-14-16.35-14C688.76,39.29,683.09,45.22,682.17,53.27Z"/><path d="M789.1,75.55l9.76,11.87c-4.22,4.48-12.53,9.89-24.66,9.89-22.28,0-36.52-15.83-36.52-36.26S753,24.39,774.07,24.39c12.79,0,20.57,5.14,24.79,9.5L788.71,46.15a20.36,20.36,0,0,0-14.51-5.8c-11.6,0-18.85,8.83-18.85,20.57,0,12.65,8.83,20.43,19,20.43C781.45,81.35,785.94,78.19,789.1,75.55Z"/><path d="M826.54,25.58h10.82v14.9H826.54V73.31c0,5.27,1.72,7.51,6.73,7.51h4.09v15a46.92,46.92,0,0,1-9.63.92c-13.32,0-18.86-6.73-18.86-18.46V40.48h-6.59V25.58h6.59V14.5h17.67Z"/></g></g></svg>
			</button>
			<div class="header-bar__hamburger-container" :class="invertClass">
				<div class="header-bar__hamburger-suite" :class="[invertClass, hamburgerClass]" @click="toggleMenu">
					<span :class="invertClass"></span>
					<span :class="invertClass"></span>
					<span :class="invertClass"></span>
				</div>

				<div class="header-bar__hamburger-menu" :class="[invertClass, hamburgerClass]">
					<button class="header-bar__nav headline-xxl button--link" :class="invertClass" @click="pushRoute('candidates')">
						{{ $t("components.common.headerBar.candidates") }}
					</button>
					<button class="header-bar__nav headline-xxl button--link" :class="invertClass" @click="pushRoute('topics')">
						{{ $t("components.common.headerBar.topics") }}
					</button>
					<button class="header-bar__nav headline-xxl button--link" :class="invertClass" @click="pushRoute('about')">
						{{ $t("components.common.headerBar.about") }}
					</button>
					<button class="header-bar__nav headline-xxl button--link" :class="invertClass" @click="pushRoute('contact')">
						{{ $t("components.common.headerBar.contact") }}
					</button>
					<div class="header-bar__nav headline-xxl" :class="invertClass" @click="openLink('https://edwardcharlesfoundation.networkforgood.com/projects/222923-myvoteproject')">
						<button class="header-bar__nav__cta headline-xxl button--link" :class="invertClass">
						{{ $t("components.common.headerBar.donate") }}
						</button>
					</div>
				</div>
			</div>
			<div class="header-bar__navBar" :class="invertClass">
				<button class="header-bar__nav headline-xs button--link" :class="invertClass" @click="pushRoute('candidates')">
					{{ $t("components.common.headerBar.candidates") }}
				</button>
				<button class="header-bar__nav headline-xs button--link" :class="invertClass" @click="pushRoute('topics')">
					{{ $t("components.common.headerBar.topics") }}
				</button>
				<button class="header-bar__nav headline-xs button--link" :class="invertClass" @click="pushRoute('about')">
					{{ $t("components.common.headerBar.about") }}
				</button>
				<button class="header-bar__nav headline-xs button--link" :class="invertClass" @click="pushRoute('contact')">
					{{ $t("components.common.headerBar.contact") }}
				</button>
				<div class="header-bar__nav headline-xs" :class="invertClass" @click="openLink('https://edwardcharlesfoundation.networkforgood.com/projects/222923-myvoteproject')">
					<button class="header-bar__nav__cta headline-xs button--link" :class="invertClass">
					{{ $t("components.common.headerBar.donate") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "headerBar",
	props: {
		inverted: {
			type: Boolean,
			default: false,
		},
		fixTop: {
			type: Boolean,
			default: false,
		},
		invertOnScroll: {
			type: Boolean,
			default: false,
		},
		menuOpen: {
			type: Boolean,
			default: false,
		},
		scrollInverted: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		invertClass() {
			if (this.scrollInverted) {
				return this.inverted ? "" : "header-bar--inverted";
			} else {
				return this.inverted ? "header-bar--inverted" : "";
			}
		},
		hamburgerClass() {
			return this.menuOpen ? "header-bar--menu-open" : "";
		},
		fixTopClass() {
			return this.fixTop ? "header-bar--fix-top" : "";
		},
	},
	created() {
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		pushRoute(destination) {
			this.$router.push({
				name: destination,
			});
		},
		openLink(destination) {
			window.open(destination, "_blank");
		},
		toggleMenu() {
			this.menuOpen = !this.menuOpen;
		},
		handleScroll() {
			if (this.fixTop && this.invertOnScroll) {
				if (
					document.body.scrollTop > 10
					|| document.documentElement.scrollTop > 10
				) {
					this.scrollInverted = true;
				} else {
					this.scrollInverted = false;
				}
			}
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../styles/global.styl';

.header-bar
	font-family: $platform
	color: $purple

	&--fix-top
		position: fixed
		top: 0
		width: 100vw

	&__logo
		width: $pxToRem(180)
		fill: $purple
		margin-left: 0.5rem
		margin-top: 0.5rem

		&.header-bar--inverted
			fill: $white

	&__navbar
		display: flex
		justify-content: flex-end
		align-items: center
		background-color: $white
		padding: 1rem
		transition: all 0.5s
		&.header-bar--inverted
			background-color: $light-purple
			transition: all 0.5s
	&__title
		margin-right: auto
		color: $purple

		&.header-bar--inverted
			color: $white

	&__hamburger-suite
		position: relative
		cursor: pointer

		& span
			display: block
			width: $pxToRem(33)
			height: $pxToRem(4)
			margin-bottom: $pxToRem(5)
			position: relative
			background: $purple
			z-index: 1
			transform-origin: $pxToRem(4) $pxToRem(0)
			transition: transform 0.3s cubic-bezier(0.77,0.2,0.05,1.0),
									background 0.3s cubic-bezier(0.77,0.2,0.05,1.0),
									opacity 0.33s ease

			&:first-child
				transform-origin: 0% 0%

			&:nth-last-child(2)
				transform-origin: 0% 100%

			&.header-bar--inverted
				background: $white

		&.header-bar--menu-open span
			opacity: 1
			transform: rotate(-45deg) translate($pxToRem(-3), $pxToRem(-1))

			&:nth-last-child(2)
				opacity: 0
				transform: rotate(0deg) scale(0.2, 0.2)

			&:nth-last-child(3)
				transform: rotate(45deg) translate(0, $pxToRem(-1))

	&__hamburger-menu
		//display: none prevents transition
		position: fixed
		left: 100vw
		visibility: hidden
		opacity: 0
		transition: opacity 1s ease

		&.header-bar--menu-open
			padding-top: $pxToRem(20)
			z-index: 2
			visibility: visible
			opacity: 1
			position: fixed
			left: 0
			top: $pxToRem(69)
			width: 100vw
			text-align: center
			transition: opacity 1s ease
			background-color: $white

		& .header-bar__nav
			display: block
			font-weight: 400
			margin-left: auto
			margin-right: auto
			margin-top: $pxToRem(40)
			margin-bottom: $pxToRem(40)

			&__cta
				font-weight: 400
				width: 80%
				max-width: $pxToRem(335)

		&.header-bar--menu-open.header-bar--inverted //consolidating menu-open causes indent err
			background-color: $light-purple

	&__navBar
		display: none

	&__nav
	&__nav__cta
		display: inline-block
		color: $purple
		margin-left: 1rem
		margin-right: 1rem
		cursor: pointer

		&.header-bar--inverted
			color: $white

	&__nav__cta
		margin-left: 0
		margin-right: 0
		background-color: $purple
		border-radius: $btnBorderRadius
		color: $white
		padding: 0.5rem 1rem 0.5rem 1rem

@media (min-width $pxToRem(900px))
	.header-bar
		&__hamburger-container
			display: none

		&__navBar
			display: inline-block

</style>
